import useGet from "api/useGet";
import * as fatchSet from "../../api/api";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { BottomErrMsg } from "component/basic/popup";
import { ContentsSection, InputSection } from "component/app/items";
import { InputItemBox, CustomSelect, TextAreaItem } from "component/basic/formItems";
import { BtnBox, BtnItem } from "component/basic/btns";
import { Header } from "component/elements/header";
import bankData from "../../data/bank.json";

const TempWorkerModify = (props) => {
    const navigate = useNavigate();
    const bottomRef = useRef(null);
    const param = useParams();
    const id = param.id

    const [type, setType] = useState('');
    const [name, setName] = useState('');
    const [birth1, setBirth1] = useState('');
    const [birth2, setBirth2] = useState('');
    const [bank, setBank] = useState('');
    const [bankAccount, setBankAccount] = useState('');
    const [incomeCode, setIncomeCode] = useState('');
    const [schoolExpenses, setSchoolExpenses] = useState('');
    const [issueDate, setIssueDate] = useState(['']);
    const [issueAmountType, setIssueAmountType] = useState(['']);
    const [issueAmount, setIssueAmount] = useState(['']);
    const [deleteIssueDate, setDeleteIssueDate] = useState([]);

    const [btnChk, setBtnChk] = useState(true);
    const [bottomMsgData, setBottomMsgData] = useState({chk : 0});

    const tempApi = useGet({url: `/temp/worker/detail?company_id=${localStorage.getItem("companyId")}&temp_worker_id=${id}`, loginType: "login"});
    const tempData = tempApi?.data?.temp_worker;

    const rateApi = useGet({url: `/rate/custom?company_id=${localStorage.getItem("companyId")}&custom_type=${type ? (type === '사업소득' ? 'business' : 'etc') : ''}`, loginType: "login"});
    const rateData = rateApi?.data?.custom_rate_items;

    function handleSubmit() {
        let formData = new FormData();
        formData.append("company_id", localStorage.getItem("companyId"));
        formData.append("temp_worker_id", id);
        formData.append("type", type);
        formData.append("name", name);
        formData.append("registration_number", birth1 + birth2);
        formData.append("bank", bank);
        formData.append("bank_account", bankAccount);
        if (type === '기타소득' || type === '사업소득') {
            if (type === '사업소득') {
                formData.append("school_expenses", schoolExpenses);
            }
            formData.append("income_code", incomeCode);
            formData.append(`issue_date[0]`, issueDate[0]?.value);
            formData.append("issue_amount_type[0]", issueAmountType[0]?.value);
            formData.append("issue_amount[0]", issueAmount[0]?.value);
        } else {
            for (let i = 0; i < issueDate?.length; i++) {
                if (issueDate[i]?.id) {
                    formData.append(`modify_issue_date[${issueDate[i]?.id}]`, issueDate[i]?.value);
                    formData.append(`modify_issue_amount_type[${issueDate[i]?.id}]`, issueAmountType[i]?.value);
                    formData.append(`modify_issue_amount[${issueDate[i]?.id}]`, issueAmount[i]?.value);
                } else {
                    formData.append(`issue_date[${i}]`, issueDate[i]?.value);
                    formData.append(`issue_amount_type[${i}]`, issueAmountType[i]?.value);
                    formData.append(`issue_amount[${i}]`, issueAmount[i]?.value);
                }
            }
        }
        for (let i = 0; i < deleteIssueDate?.length; i++) {
            formData.append(`delete_issue_date[${i}]`, deleteIssueDate[i]);
        }

        fatchSet.FatchApi({
            type: "POST",
            formDataItem: formData,
            url: "/temp/worker/modify",
            loginType: "login",
            success: (data) => {
                navigate(`/tempWorker?message=일시 근무자 정보 수정이 완료되었습니다.`);
            },
            err: (data) => {
                if (data.data || data.alert) {
                    setBottomMsgData({
                        text: data.alert || "",
                        chk: bottomMsgData.chk + 1
                    });
                }
            }
        })
    }

    useEffect(() => {
        if (tempData) {
            setType(tempData?.type)
            setName(tempData?.name)
            setBirth1(tempData?.registration_number?.slice(0, 6))
            setBirth2(tempData?.registration_number?.slice(6, 7))
            setBank(tempData?.bank)
            setBankAccount(tempData?.bank_account)
            setIncomeCode(tempData?.income_code)
            setSchoolExpenses(tempData?.school_expenses)

            let newIssueDate = [];
            let newIssueAmountType = [];
            let newIssueAmount = [];
            tempData?.issues?.map((issue) => {
                newIssueDate.push({id : issue?.id, value: issue?.date})
                newIssueAmountType.push({id : issue?.id, value: issue?.amount_type})
                newIssueAmount.push({id : issue?.id, value: issue?.amount})
            })

            setIssueDate(newIssueDate)
            setIssueAmountType(newIssueAmountType)
            setIssueAmount(newIssueAmount)
        }
    }, [tempData]);

    useEffect(() => {
        if (bottomRef.current) {
            bottomRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [issueDate?.length]);

    useEffect(() => {
        if (type === '기타소득') {
            if (birth1 !== "" && birth2 !== "" && bank !== "" && bankAccount !== "" && incomeCode !== "" && issueDate?.length > 0 && issueAmountType?.length > 0 && issueAmount?.length > 0) {
                setBtnChk(false)
            } else {
                setBtnChk(true)
            }
        } else if (type === '사업소득') {
            if (birth1 !== "" && birth2 !== "" && bank !== "" && bankAccount !== "" && incomeCode !== "" && schoolExpenses !== "" && issueDate?.length > 0 && issueAmountType?.length > 0 && issueAmount?.length > 0) {
                setBtnChk(false)
            } else {
                setBtnChk(true)
            }
        } else if (type === '일용직 근무') {
            if (birth1 !== "" && birth2 !== "" && bank !== "" && bankAccount !== "" && issueDate?.length > 0 && issueAmountType?.length > 0 && issueAmount?.length > 0) {
                setBtnChk(false)
            } else {
                setBtnChk(true)
            }
        }
    }, [type, birth1, birth2, bank, bankAccount, incomeCode, schoolExpenses, issueDate, issueAmountType, issueAmount]);

    return (
        <>
            <Header
                pageBack={true}
                func={() => {
                    navigate(-1)
                }}
                headTitle="일시 근무자 수정"
                centerTitle={true}
            />
            <ContentsSection addClass="headerContents btnContents">
                <InputSection addClass="registerSection">
                    <CustomSelect
                        inputTitle="구분 선택"
                        placeholder="선택"
                        value={type}
                        func={(name, val, subVal) => {
                            setType(val);
                            setIncomeCode('')
                        }}
                        disabled={false}
                        valKey="id"
                        nameKey="name"
                        options={[
                            {id: '기타소득', name: '기타소득'},
                            {id: '사업소득', name: '사업소득'},
                            {id: '일용직 근무', name: '일용직 근무'},
                        ]}
                    />
                    <InputItemBox
                        inputType="text"
                        inputTitle="이름"
                        placeholder="이름 입력"
                        value={name}
                        max={null}
                        regexp={null}
                        func={(value) => {setName(value)}}
                    />
                    <div className="companyBtnTextBox mt-20">
                        <InputItemBox
                            addClass=""
                            boxAddClass="col2"
                            inputTitle="주민등록번호"
                            placeholder="000000"
                            value={birth1}
                            func={(value) => {setBirth1(value);}}
                            disabled={false}
                            maxLength={6}
                        />
                        <div className="hyphen">-</div>
                        <InputItemBox
                            placeholder="0"
                            boxAddClass="col2"
                            value={birth2}
                            func={(value) => {setBirth2(value);}}
                            disabled={false}
                            maxLength={1}
                        />
                    </div>
                    <CustomSelect
                        inputTitle="계좌번호"
                        placeholder="은행 선택"
                        value={bank}
                        func={(name, val, subVal) => {
                            setBank(val);
                        }}
                        disabled={false}
                        valKey="name"
                        nameKey="name"
                        options={bankData?.bankCades}
                    />
                    <InputItemBox
                        inputType="text"
                        boxAddClass="mb-20 m-0"
                        placeholder="계좌번호를 입력해주세요"
                        value={bankAccount}
                        max={null}
                        regexp={null}
                        func={(value) => {setBankAccount(value)}}
                    />
                    {(type === '기타소득' || type === '사업소득') && (<>
                        <InputItemBox
                            inputType="date"
                            inputTitle="지급 일자"
                            addClass={"inputDate"}
                            placeholder="일자 선택"
                            value={issueDate[0]?.value}
                            func={(value) => {
                                let newIssueDate = [...issueDate];
                                newIssueDate[0].value = value;
                                setIssueDate(newIssueDate);
                            }}
                            max={null}
                            regexp={null}
                        />
                        <CustomSelect
                            inputTitle="소득별 코드"
                            placeholder="선택"
                            value={incomeCode}
                            func={(name, val, subVal) => {
                                setIncomeCode(val);
                            }}
                            disabled={false}
                            valKey="id"
                            nameKey="type_name"
                            options={rateData ? rateData : []}
                        />
                        {type === '사업소득' && (
                            <InputItemBox
                                inputType="text"
                                inputTitle="학자금 공제"
                                placeholder="학자금 공제 금액"
                                value={schoolExpenses}
                                max={null}
                                regexp={null}
                                func={(value) => {setSchoolExpenses(value)}}
                            />
                        )}
                        <CustomSelect
                            inputTitle="지급 금액"
                            placeholder="선택"
                            value={issueAmountType[0]?.value}
                            func={(name, val, subVal) => {
                                let newIssueAmountType = [...issueAmountType];
                                newIssueAmountType[0].value = val;
                                setIssueAmountType(newIssueAmountType);
                            }}
                            disabled={false}
                            valKey="id"
                            nameKey="name"
                            options={[
                                {id: 'before', name: '세전'},
                                {id: 'after', name: '세후'}
                            ]}
                        />
                        <InputItemBox
                            inputType="text"
                            boxAddClass="mb-20 m-0"
                            placeholder="지급 금액"
                            value={issueAmount[0]?.value}
                            max={null}
                            regexp={null}
                            func={(value) => {
                                let newIssueAmount = [...issueAmount];
                                newIssueAmount[0].value = value;
                                setIssueAmount(newIssueAmount);
                            }}
                        />
                    </>)}
                    {type === '일용직 근무' && (<>
                        {issueDate?.map((date, dateKey) => (
                            <>
                                <div className="inputButtonBox">
                                    <InputItemBox
                                        inputType="date"
                                        inputTitle={dateKey === 0 ? `지급 일자` : <>&nbsp;</>}
                                        boxAddClass="mb-10"
                                        addClass={"inputDate"}
                                        placeholder="일자 선택"
                                        value={date?.value}
                                        func={(value) => {
                                            let newIssueDate = [...issueDate];
                                            newIssueDate[dateKey].value = value;
                                            setIssueDate(newIssueDate);
                                        }}
                                        max={null}
                                        regexp={null}
                                    />
                                    <button onClick={() => {
                                        if (dateKey === 0) {
                                            setIssueDate(() => issueDate.concat({id: '', value: ''}))
                                            setIssueAmountType(() => issueAmountType.concat({id: '', value: ''}))
                                            setIssueAmount(() => issueAmount.concat({id: '', value: ''}))
                                        } else {
                                            if (date?.id) {
                                                setDeleteIssueDate(() => deleteIssueDate.concat(date?.id));
                                            }

                                            let newIssueDate = [...issueDate]; newIssueDate.splice(dateKey, 1); setIssueDate(newIssueDate);
                                            let newIssueAmountType = [...issueAmountType]; newIssueAmountType.splice(dateKey, 1); setIssueAmountType(newIssueAmountType);
                                            let newIssueAmount = [...issueAmount]; newIssueAmount.splice(dateKey, 1); setIssueAmount(newIssueAmount);
                                        }
                                    }}>
                                        <img src={`${dateKey === 0 ? '/assets/images/basic/plusButton.svg' : '/assets/images/basic/minusButton.svg'}`}/>
                                    </button>
                                </div>
                                <div className="inputSelectBox">
                                    <CustomSelect
                                        placeholder="선택"
                                        boxAddClass="m-0"
                                        value={issueAmountType[dateKey]?.value}
                                        func={(name, val, subVal) => {
                                            let newIssueAmountType = [...issueAmountType];
                                            newIssueAmountType[dateKey].value = val;
                                            setIssueAmountType(newIssueAmountType);
                                        }}
                                        disabled={false}
                                        valKey="id"
                                        nameKey="name"
                                        options={[
                                            {id: 'before', name: '세전'},
                                            {id: 'after', name: '세후'}
                                        ]}
                                    />
                                    <InputItemBox
                                        inputType="text"
                                        boxAddClass="m-0"
                                        placeholder="지급 금액"
                                        value={issueAmount[dateKey]?.value}
                                        max={null}
                                        regexp={null}
                                        func={(value) => {
                                            let newIssueAmount = [...issueAmount];
                                            newIssueAmount[dateKey].value = value;
                                            setIssueAmount(newIssueAmount);
                                        }}
                                    />
                                </div>
                            </>
                        ))}
                    </>)}
                </InputSection>
                <BtnBox
                    boxType="fixed"
                    addClass=""
                >
                    <BtnItem
                        addClass=""
                        contents={"수정하기"}
                        disabled={btnChk}
                        func={() => { handleSubmit() }}
                    />
                </BtnBox>
                <div ref={bottomRef}/>
            </ContentsSection>
            <BottomErrMsg
                text={bottomMsgData.text ? bottomMsgData.text : ""}
                chk={bottomMsgData.chk}
            />
        </>
    );
};

export default TempWorkerModify;